@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (taskMessage()) {
    <div class="taskMessage">
      <p>{{ taskMessage() }}</p>
    </div>
  }
  @if (task()) {
    <div class="taskDetail">
      <div class="displayRow">
        <label class="inputLabel">Task Name:</label>
        <label class="displayLabel">{{ task().name }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Started:</label>
        <label class="displayLabel">{{ task().startTime | date: 'M/d/yyyy hh:mm a' }}</label>
      </div>
      @if (task().escalationTime) {
        <div class="displayRow">
          <label class="inputLabel">Will Escalate:</label>
          <label class="displayLabel">{{ task().escalationTime | date: 'M/d/yyyy hh:mm a' }}</label>
        </div>
      }
      @if (task().autoCompleteTime) {
        <div class="displayRow">
          <label class="inputLabel">Will Autocomplete:</label>
          <label class="displayLabel">{{ task().autoCompleteTime | date: 'M/d/yyyy hh:mm a' }}</label>
        </div>
      }
      <div class="displayRow">
        <label class="inputLabel">Assigned To:</label>
        <label class="displayLabel">{{ assignedTo() }}</label>
      </div>
    </div>
  }
  @if (entity()) {
    <div class="entityDetail">
      <div class="displayRow">
        <label class="inputLabel">Entity ID:</label>
        <a class="displayLabel" [href]="getEntityUrl()">{{ entity().id.entityId + ';' + entity().id.entityRevision }}</a>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Project:</label>
        <label class="displayLabel">{{ entity().projectName }}</label>
      </div>
    </div>
  }
  @if (fpaTaskData()) {
    <div class="fpa-data">
      <div class="displayRow">
        <label class="inputLabel">Outside Sales Rep:</label>
        <label class="displayLabel">{{ fpaTaskData().outsideSalesRep }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Rep Office:</label>
        <label class="displayLabel">{{ fpaTaskData().repOffice }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Lead Time:</label>
        <label class="displayLabel">{{ fpaTaskData().leadTime }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Total List:</label>
        <label class="displayLabel">{{ fpaTaskData().totalList | currency: 'USD' }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Unit Qty:</label>
        <label class="displayLabel">{{ fpaTaskData().unitQuantity }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Published Multiplier:</label>
        <label class="displayLabel">{{ fpaTaskData().publishedMultiplier }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Requested Multiplier:</label>
        <label class="displayLabel">{{ fpaTaskData().requestedMultiplier }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Margin &#64; Req Mult:</label>
        <label class="displayLabel">{{ fpaTaskData().margin }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Sale Type:</label>
        <label class="displayLabel">{{ fpaTaskData().saleType }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Approval Status:</label>
        <label class="displayLabel">{{ fpaTaskData().approvalStatus }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Expected First Shipment:</label>
        <label class="displayLabel">{{ fpaTaskData().expectedFirstShipment }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Basis Of Design:</label>
        <label class="displayLabel">{{ fpaTaskData().basisOfDesign }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Competitor:</label>
        <label class="displayLabel">{{ fpaTaskData().competitor }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Specifying Engineer:</label>
        <label class="displayLabel">{{ fpaTaskData().specifyingEngineer }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Engineer Location:</label>
        <label class="displayLabel">{{ fpaTaskData().engineerLocation }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Bid Date:</label>
        <label class="displayLabel">{{ fpaTaskData().bidDate }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Other Details:</label>
        <label class="displayLabel">{{ fpaTaskData().otherDetails }}</label>
      </div>
    </div>
  }
    @if (userApplication()) {
    <div class="user-application-data">
      <div class="displayRow">
        <label class="inputLabel">Applicant First Name:</label>
        <label class="displayLabel">{{ userApplication().firstName }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Applicant Last Name:</label>
        <label class="displayLabel">{{ userApplication().lastName }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Organization ID:</label>
        <label class="displayLabel">{{ userApplication().orgName }}</label>
      </div>
      @if (userApplicationOrganization()) {
        <div class="displayRow">
          <label class="inputLabel">Organization:</label>
          <label class="displayLabel">{{ userApplicationOrganization().description }}</label>
        </div>
      }
      @if (userApplicationParentOrganization()) {
        <div class="displayRow">
          <label class="inputLabel">Parent Org ID:</label>
          <label class="displayLabel">{{ userApplicationParentOrganization().orgUnitId }}</label>
        </div>
        <div class="displayRow">
          <label class="inputLabel">Parent Org:</label>
          <label class="displayLabel">{{ userApplicationParentOrganization().description }}</label>
        </div>
      }
      <div class="displayRow">
        <label class="inputLabel">E-mail:</label>
        <label class="displayLabel">{{ userApplication().workEmail }}</label>
      </div>
      <div class="displayRow">
        <label class="inputLabel">Phone:</label>
        <label class="displayLabel">{{ userApplication().phoneNumber }}</label>
      </div>
    </div>
  }
  @if (canCloseTask()) {
    <div class="buttonRow">
      <label class="inputLabel"></label>
      <button matButton="elevated" class="buttonInput approveButton" (click)="closeTask(true)">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <label class="buttonLabel">Approve</label>
        </span>
      </button>
      <button matButton="elevated" class="buttonInput denyButton" (click)="closeTask(false)">
        <span>
          <mat-icon class="size-16">cancel</mat-icon>
          <label class="buttonLabel">Deny</label>
        </span>
      </button>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
